export const SETPAGENO = 'SETPAGENO';
export const SETCURRENTSCROLLPOSITION = 'SETCURRENTSCROLLPOSITION';
export const ONEXITLEADSPAGE = 'ONEXITLEADSPAGE';